import { type ReactNode } from 'react';

const styles = `
/* increase specificity of selector to override injected styles */
.be-ix-link-block.be-ix-link-block.be-ix-link-block.be-ix-link-block.be-ix-link-block.be-ix-link-block.be-ix-link-block.be-ix-link-block.be-ix-link-block * {
  font-family: Montserrat;
  font-weight: 400;
  font-size: 12px;
  color: rgb(0 0 0 / 0.75);
  text-decoration: none;
  margin: 0;
  padding: 0;
  display: inline;

  @media(min-width: 1024px) {
    & {
      font-size: 14px;
    }
  }

  --_text-gap: 3px;

  &.be-label::after {
    content: ":";
    margin-right: var(--_text-gap);
  }

  &.be-list-item:not(:last-child)::after {
    content: ",";
    margin-right: var(--_text-gap);
  }
}

`;

export function BrightEdgeContainer({ divider }: { divider: ReactNode }) {
  return (
    <>
      <div className="be-ix-link-block" />
      <style>{styles}</style>
      {divider}
    </>
  );
}
